import { MARKETING_CHANNEL_ID } from '../../../theme/theme.constants';
import { SERVICE_NAME } from './otp.constants';

const getServiceNameByMarketChannelId = (marketChannelId) => {
  if (!marketChannelId) {
    return '';
  }

  switch (marketChannelId) {
    case MARKETING_CHANNEL_ID.figo:
      return SERVICE_NAME.FIGO;
    case MARKETING_CHANNEL_ID.ppu:
    case MARKETING_CHANNEL_ID.ppuPetCare:
      return SERVICE_NAME.PPU;
    case MARKETING_CHANNEL_ID.spot:
    case MARKETING_CHANNEL_ID.spotCan:
      return SERVICE_NAME.SPOT;
    // Futurama only :)
    case MARKETING_CHANNEL_ID.ppi:
      return SERVICE_NAME.SPOT;
    default:
      return null;
  }
};

export { getServiceNameByMarketChannelId };
